var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"id":"feedback-added","modifier":"testimonial"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var close = ref.close;
return [_c('div',{staticClass:"close",on:{"click":close}},[_c('SvgIcon',{attrs:{"name":"close"}})],1),_c('h2',[_vm._v(_vm._s(_vm.$t('ModalFeedbackAdded.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('ModalFeedbackAdded.text')))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }